import axios from 'axios';
import { UserFilterApiService } from '@/api/userProfile/UserFilterApiService';
import { migrateSharedViewKeys } from '@/utils/filter/filterKeyMigrations';
import { parseSharedViewPayload } from '@/utils/filter/parseSharedViewPayload';
import { unwrapS3Response, validateS3Url } from '@/utils/filter/unwrapS3Response';

const VERIFY_RETRY_DELAY_MS = 300;

const canReadSharedView = async (sharedFilterId: string): Promise<boolean> => {
  try {
    const detailResponse = await UserFilterApiService.getFilterById(sharedFilterId);
    const { filters_download_link: downloadLink } = detailResponse.data;
    validateS3Url(downloadLink);

    const filtersResponse = await axios.get<Record<string, unknown>>(downloadLink);
    const migrated = migrateSharedViewKeys(unwrapS3Response(filtersResponse.data));
    return parseSharedViewPayload(migrated) !== null;
  } catch {
    return false;
  }
};

const wait = (ms: number): Promise<void> =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export const verifyPublishedSharedView = async (sharedFilterId: string): Promise<boolean> => {
  if (await canReadSharedView(sharedFilterId)) return true;
  await wait(VERIFY_RETRY_DELAY_MS);
  return canReadSharedView(sharedFilterId);
};
